import { useTranslation } from 'react-i18next';
import i18n from '../index';
import fr from './fr.json';
import en from './en.json';
import es from './es.json';

export const EDITOR_NS = 'editor';

i18n.addResourceBundle('fr', EDITOR_NS, fr, true, false);
i18n.addResourceBundle('en', EDITOR_NS, en, true, false);
i18n.addResourceBundle('es', EDITOR_NS, es, true, false);

export type EditorLang = 'fr' | 'en' | 'es';

const LOCALES: Record<EditorLang, string> = { fr: 'fr-FR', en: 'en-GB', es: 'es-ES' };

export const EDITOR_LANGUAGES: { code: EditorLang; flag: string; name: string }[] = [
  { code: 'fr', flag: '🇫🇷', name: 'Français' },
  { code: 'en', flag: '🇬🇧', name: 'English' },
  { code: 'es', flag: '🇪🇸', name: 'Español' },
];

export const resolveLang = (raw?: string): EditorLang => {
  const base = (raw || 'fr').toLowerCase().split('-')[0];
  return (base === 'en' || base === 'es' ? base : 'fr') as EditorLang;
};

export const changeEditorLanguage = (lang: EditorLang) => i18n.changeLanguage(lang);

/** Editor translation hook: French source text is the key. */
export const useEditorT = () => {
  const { t, i18n: inst } = useTranslation(EDITOR_NS);
  const lang = resolveLang(inst.resolvedLanguage || inst.language);
  const te = (key: string, options?: Record<string, unknown>) =>
    t(key, { keySeparator: false, nsSeparator: false, defaultValue: key, ...(options || {}) }) as string;
  return { te, lang, locale: LOCALES[lang] };
};

export default i18n;
